// extracted by mini-css-extract-plugin
export default {"table":"totalTable_table__+hpvg"};